import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/shared/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/ui/select";
import { Textarea } from "@/shared/ui/textarea";
import { CurrencyInput, type CurrencyCode } from "@/shared/ui/currency-input";
import { TaxFormValues } from "./utils";
import { ReceivableCurrency , ReceivableTaxType} from "../../utils";

interface TaxFormFieldsProps {
  form: UseFormReturn<TaxFormValues>;
  disabled?: boolean;
  /** Bloqueia apenas o campo valor (ex: taxa já salva) */
  valueDisabled?: boolean;
}

export function TaxFormFields({ form, disabled, valueDisabled = false }: TaxFormFieldsProps) {
  const currency = form.watch("currency");

  return (
    <>
      <div className="grid gap-4 md:grid-cols-2">
        <FormField
          control={form.control}
          name="currency"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Moeda</FormLabel>
              <Select value={field.value} onValueChange={field.onChange} disabled={disabled}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Selecione a moeda" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value={ReceivableCurrency.BRL}>BRL</SelectItem>
                  <SelectItem value={ReceivableCurrency.USD}>USD</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="type"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Tipo</FormLabel>
              <Select value={field.value} onValueChange={field.onChange} disabled={disabled}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Selecione o tipo" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {Object.values(ReceivableTaxType).map((type) => (
                    <SelectItem key={type} value={type}>
                      {type}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="value"
        render={({ field }) => {
          const numValue =
            typeof field.value === "number" && !isNaN(field.value)
              ? field.value
              : typeof field.value === "string"
                ? Number(field.value)
                : undefined;
          const safeValue = numValue !== undefined && !isNaN(numValue) ? numValue : undefined;

          return (
            <FormItem>
              <FormLabel>Valor</FormLabel>
              <FormControl>
                <CurrencyInput
                  value={safeValue}
                  onValueChange={(val) => field.onChange(val)}
                  currency={currency as CurrencyCode}
                  disabled={disabled || valueDisabled}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />

      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Descrição (opcional)</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Detalhes adicionais sobre a taxa"
                value={field.value ?? ""}
                onChange={field.onChange}
                disabled={disabled}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}

